// Colunas da planilha de valores variáveis (importação em lote de /c/contracts).
// O modelo sai com os rótulos em português; a leitura aceita também os nomes em
// inglês do modelo antigo, para planilhas já preenchidas continuarem valendo.
export const VALUE_SHEET_COLUMNS = [
  { key: "contract_id", label: "Contrato", required: true },
  { key: "document", label: "CPF/CNPJ", required: true },
  { key: "name", label: "Prestador" },
  { key: "project_name", label: "Projeto" },
  { key: "value", label: "Valor", required: true },
];

const normalizeHeader = (header) =>
  header
    .toString()
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");

// Cabeçalho normalizado -> chave interna. Inclui os nomes em inglês do modelo antigo.
const HEADER_ALIASES = {
  contrato: "contract_id",
  contract_id: "contract_id",
  "cpf/cnpj": "document",
  cpf: "document",
  cnpj: "document",
  documento: "document",
  document: "document",
  prestador: "name",
  nome: "name",
  name: "name",
  projeto: "project_name",
  project_name: "project_name",
  valor: "value",
  "valor (r$)": "value",
  value: "value",
};

/** Converte uma linha lida da planilha para as chaves internas; colunas desconhecidas são descartadas. */
export function normalizeValueSheetRow(row) {
  const normalized = {};
  Object.entries(row).forEach(([header, value]) => {
    const key = HEADER_ALIASES[normalizeHeader(header)];
    if (key && normalized[key] === undefined) {
      normalized[key] = value;
    }
  });
  return normalized;
}

export const valueSheetLabel = (key) => VALUE_SHEET_COLUMNS.find((c) => c.key === key)?.label || key;

/**
 * Valor da célula em número. Célula numérica passa direto; texto vale no formato
 * brasileiro ("1.500,00", "R$ 2.000", "1500,5") ou com ponto decimal ("1500.50").
 * O que não é número vira `NaN` (antes, o `parseFloat` lia "1.500,00" como 1,5).
 */
export function parseSheetMoney(value) {
  if (typeof value === "number") return value;
  if (value === undefined || value === null) return NaN;
  let text = value.toString().replace(/R\$/i, "").replace(/\s/g, "");
  if (!text) return NaN;
  if (text.includes(",")) {
    text = text.replace(/\./g, "").replace(",", ".");
  } else if (/^-?\d{1,3}(\.\d{3})+$/.test(text)) {
    text = text.replace(/\./g, "");
  }
  return /^-?\d+(\.\d+)?$/.test(text) ? Number(text) : NaN;
}
